import { WhiteLabelSubdomainInfo } from '../../api/budgetApiClient'
import { AuthenticateSmartcheckSessionDto } from '../../types/authenticateSmartcheckSessionDto'
import { Error } from '../../types/error'
import {
	FluxStandardAction,
	FluxStandardFailureAction,
} from '../../types/fluxStandardAction'

export type AuthenticateWithApplicantIdAction = FluxStandardAction<
	'smartCheckFlowOrchestrator/authenticateWithApplicantId',
	{
		applicantId: string
	}
>

const AUTHENTICATE_SUCCEEDED_WITH_SUBDOMAIN =
	'smartCheckFlowOrchestrator/authenticateWithSubdomain' as const
export type AuthenticateSucceededWithSubdomainAction = FluxStandardAction<
	typeof AUTHENTICATE_SUCCEEDED_WITH_SUBDOMAIN,
	WhiteLabelSubdomainInfo
>

export type ReAuthenticateAction = FluxStandardAction<
	'smartCheckFlowOrchestrator/reAuthenticate',
	{
		applicantId: string
		token: string
	}
>

export type AuthenticateSucceededAction = FluxStandardAction<
	'smartCheckFlowOrchestrator/authenticateSucceeded',
	{
		applicantId: string
		smartCheckAuthenticationDto: AuthenticateSmartcheckSessionDto
	}
>

export type AuthenticateFailedAction =
	FluxStandardFailureAction<'smartCheckFlowOrchestrator/authenticateFailed'>

export type AuthenticateAction =
	| AuthenticateWithApplicantIdAction
	| AuthenticateSucceededAction
	| AuthenticateFailedAction
	| AuthenticateSucceededWithSubdomainAction

export function authenticateWithApplicantId(
	applicantId: string,
): AuthenticateWithApplicantIdAction {
	return {
		type: 'smartCheckFlowOrchestrator/authenticateWithApplicantId',
		payload: {
			applicantId,
		},
	}
}

export const authenticateWithSubdomain = (
	data: WhiteLabelSubdomainInfo,
): AuthenticateSucceededWithSubdomainAction => ({
	type: AUTHENTICATE_SUCCEEDED_WITH_SUBDOMAIN,
	payload: data,
})

export function reAuthenticate(
	applicantId: string,
	token: string,
): ReAuthenticateAction {
	return {
		type: 'smartCheckFlowOrchestrator/reAuthenticate',
		payload: {
			applicantId,
			token,
		},
	}
}

export function authenticateSucceeded(
	applicantId: string,
	smartCheckAuthenticationDto: AuthenticateSmartcheckSessionDto,
): AuthenticateSucceededAction {
	return {
		type: 'smartCheckFlowOrchestrator/authenticateSucceeded',
		payload: {
			applicantId,
			smartCheckAuthenticationDto,
		},
	}
}

export function authenticateFailed(
	authenticateError: Error,
): AuthenticateFailedAction {
	return {
		type: 'smartCheckFlowOrchestrator/authenticateFailed',
		payload: authenticateError,
		error: true,
	}
}
